import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'psycologists-impact-cases',
    component: () => import(/* webpackChunkName: "psycologists" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '', 
            name: 'psycologists-impact-cases-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.psycologists-impact-cases',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "psycologists-impact-cases" */ '@/modules/psycologists/impact-cases/views/Index.vue')
        }
    ]    
}